export default __webpack_public_path__ + "static/media/navigation.1f51a89d.yaml";